import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'app-landing-layout',
  templateUrl: './landing-layout.component.html',
  styleUrls: ['./landing-layout.component.scss'],
  standalone: false
})
export class LandingLayoutComponent implements OnInit {

  currentSection = 'home';
  public isCollapsed = true;
  
  constructor(
    private _cookieService: CookieService,

    public translate: TranslateService) { }


  ngOnInit(): void {
 
  }

  /**
* Section changed method
* @param sectionId specify the current sectionID
*/
  onSectionChange(sectionId: string) {
    this.currentSection = sectionId;
  }



  // When the user clicks on the button, scroll to the top of the document
  topFunction() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  }

  setLanguage(lang: string) {

  }
  //find language from cookies, ar or en only for now
  isArLang() {
    return this._cookieService.get('lang')== 'ar'? true : false;
  }


}
